export const formatMoney = value => new window.Intl.NumberFormat('en-IE', {
  style: 'currency', currency: 'EUR', maximumFractionDigits: 0,
}).format(Number(value || 0));

export const formatCurrency = (value, currency = 'EUR') => new window.Intl.NumberFormat('en-IE', {
  style: 'currency', currency: currency || 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2,
}).format(Number(value || 0));

export const formatMinorMoney = (minor, currency = 'EUR') => (
  formatCurrency(Number(minor || 0) / 100, currency)
);

export const formatPercent = value => `${new window.Intl.NumberFormat('en-IE', {
  minimumFractionDigits: 1, maximumFractionDigits: 1,
}).format(Number(value || 0))}%`;

export const formatControlValue = value => {
  if (value === null || value === undefined || value === '') return 'Not available';
  const numeric = Number(value);
  if (Number.isNaN(numeric)) return String(value);
  const clean = Math.abs(numeric) < 1e-9 ? 0 : numeric;
  return new window.Intl.NumberFormat('en-IE', { maximumFractionDigits: 2 }).format(clean);
};

export const formatRenewalDays = days => {
  if (days === 0) return 'Today';
  const amount = Math.abs(days);
  const unit = amount === 1 ? 'day' : 'days';
  return days < 0 ? `${amount} ${unit} overdue` : `${amount} ${unit}`;
};

export const formatDate = value => value ? new window.Intl.DateTimeFormat('en-GB', {
  day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC',
}).format(new Date(value)) : 'Not recorded';

export const formatMadridDateTime = value => value ? new window.Intl.DateTimeFormat('en-GB', {
  day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
  hour12: false, timeZone: 'Europe/Madrid',
}).format(new Date(value)) : 'Not recorded';

export const movementLabel = value => ({
  NEW: 'New', REACTIVATION: 'Reactivation', EXPANSION: 'Expansion',
  CONTRACTION: 'Contraction', CHURN: 'Churn',
}[value] || value || 'No movement');
